<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ $t('messages.set_province') }}</h4>
                  <p>{{ $t('messages.select_province_to_continue') }}</p>
                </div>

                <div class="mb-8">
                  <label class="vs-input--label">{{ $t('users.addresses.province') }}</label>
                  <v-select
                    v-model="province"
                    :clearable="false"
                    :options="provinceOptions"
                    :reduce="option => option.value"
                    name="province"
                    v-validate="'required'"
                    :data-vv-as="$t('users.addresses.province')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('province')">{{
                    errors.first('province')
                  }}</span>
                </div>

                <vs-button
                  :disabled="!validateForm"
                  @click="save_changes"
                  class=" px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                  >{{ $t('button.confirm') }}</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      province: ''
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    },
    provinceOptions() {
      return [
        { value: 'استان کرمان', label: 'کرمان' },
        { value: 'استان خراسان رضوی', label: 'خراسان رضوی' },
        { value: 'استان تهران', label: 'تهران' },
        { value: 'استان خراسان شمالی', label: 'خراسان شمالی' },
        { value: 'استان ایلام', label: 'ایلام' },
        { value: 'استان لرستان', label: 'لرستان' },
        { value: 'استان مرکزی', label: 'مرکزی' },
        { value: 'استان چهارمحال و بختیاری', label: 'چهارمحال و بختیاری' },
        { value: 'استان کرمانشاه', label: 'کرمانشاه' },
        { value: 'استان همدان', label: 'همدان' },
        { value: 'استان قزوین', label: 'قزوین' },
        { value: 'استان گیلان', label: 'گیلان' },
        { value: 'استان زنجان', label: 'زنجان' },
        { value: 'استان سمنان', label: 'سمنان' },
        { value: 'استان اصفهان', label: 'اصفهان' },
        { value: 'استان کهگیلویه و بویر احمد', label: 'کهگیلویه و بویر احمد' },
        { value: 'استان کردستان', label: 'کردستان' },
        { value: 'استان آذربایجان غربی', label: 'آذربایجان غربی' },
        { value: 'استان فارس', label: 'فارس' },
        { value: 'استان بوشهر', label: 'بوشهر' },
        { value: 'استان اردبیل', label: 'اردبیل' },
        { value: 'استان مازندران', label: 'مازندران' },
        { value: 'استان گلستان', label: 'گلستان' },
        { value: 'استان خراسان جنوبی', label: 'خراسان جنوبی' },
        { value: 'استان سیستان و بلوچستان', label: 'سیستان و بلوچستان' },
        { value: 'استان قم', label: 'قم' },
        { value: 'استان البرز', label: 'البرز' },
        { value: 'استان آذربایجان شرقی', label: 'آذربایجان شرقی' },
        { value: 'استان یزد', label: 'یزد' },
        { value: 'استان هرمزگان', label: 'هرمزگان' },
        { value: 'استان خوزستان', label: 'خوزستان' }
      ]
    }
  },
  methods: {
    save_changes() {
      if (!this.validateForm) return
      // eslint-disable-next-line no-unused-vars
      const { id, ...userData } = this.$store.state.AppActiveUser
      if (userData.details) delete userData.details['_id']
      if (userData.location) delete userData.location['_id']
      if (userData.password) delete userData['password']
      this.$store
        .dispatch('auth/editProfile', { ...userData, province: this.province })
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          this.$store.commit('UPDATE_USER_INFO', {
            displayName: `${res.data.details.firstName} ${res.data.details.lastName}`,
            ...res.data
          })
          if (this.$route.query.to) this.$router.push(this.$route.query.to)
          else this.$router.push({ name: 'dashboard' })
        })
    }
  }
}
</script>
